import findIndex from 'lodash-es/findIndex'
import head from 'lodash-es/head'
import filter from 'lodash-es/filter'

export default {
  namespaced: true,
  state: {
    allPages: [],
    pages: [],

    pageCat: 1,
    page_actual: {},
    page_n: 1,
    page_prev: 1,
    page_next: 2,
    formState: 0,
    canNext: true,
    canPrev: false
  },
  mutations: {
    init(state) {
      state.page_actual = head(state.allPages)
    },
    update(state) {
      const pages = filter(state.allPages, page => page.elegible)

      state.pages = pages

      const indexAtual = findIndex(pages, function (p) {
        return p.the_n === state.page_n
      })

      state.canPrev = (indexAtual > 0)
    },
    setPages(state, payload) {
      state.allPages = payload
    },
    pageNav (state, payload) {
      let next = null
      let type = null

      if (typeof payload === 'object') {
        type = payload.type
        next = payload.next
      } else {
        type = payload
      }

      const pages = state.pages

      const getIndexPageByN = n => findIndex(pages, function (p) {
        return p.the_n === n
      })

      if (type === 'next') {
        state.page_prev = state.page_n
        state.page_n = next
        state.page_actual = pages[getIndexPageByN(next)]
      }

      if (type === 'prev') {
        state.page_n = state.page_prev
        state.page_actual = pages[getIndexPageByN(state.page_prev)]
      }

      // state.canPrev = (nextIndex > 0)
    },
    canNext (state, can = true) {
      state.canNext = can
    },
    changePageCat (state, cat) {
      state.pageCat = cat
    },
  },
  actions: {
    prevPage(context) {
      context.commit('update')
      context.commit('pageNav', 'prev')
    },
    nextPage(context, next) {
      context.commit('update')
      context.commit('pageNav', { type: 'next', next })
    }
  }
}